/* eslint-disable react/no-array-index-key */
import useTranslation from "@/hooks/useTranslation";
import { SearchContentListItem } from "@/interfaces/pubmed.interface";
import { Typography } from "antd";
import React, { useMemo } from "react";
import AuthorDescription from "./components/AuthorDescription";
import JournalDescription from "./components/JournalDescription";
import styles from "./styles.module.less";

const { Paragraph } = Typography;
const { journalStyle, authorStyle } = styles;

interface IProps {
  description: Pick<
    SearchContentListItem,
    | "authors"
    | "journalInfo"
    | "publicationTypes"
    | "eDoi"
    | "ePmid"
    | "articleDate"
    | "articleIds"
    | "journal"
    | "medlineJournalInfo"
  >;
}

const Description: React.FC<IProps> = (props) => {
  const {
    description: {
      authors,
      journalInfo,
      publicationTypes,
      eDoi,
      ePmid,
      articleDate,
      articleIds,
      journal,
      medlineJournalInfo,
    },
  } = props;

  const { t } = useTranslation("explore");

  const { pmid, doi } = useMemo(() => {
    const aPmid = articleIds.find((e) => e?.idType?.toLowerCase() === "pubmed")
      ?.id;
    const aDoi = articleIds.find((e) => e?.idType?.toLowerCase() === "doi")?.id;
    return {
      pmid: ePmid || aPmid,
      doi: eDoi || aDoi,
    };
  }, [articleIds, eDoi, ePmid]);

  const authorDict = {
    lastName: t("pubmed.author.last-name"),
    foreName: t("pubmed.author.fore-name"),
    initials: t("pubmed.author.initials"),
    followed: t("pubmed.author.followed"),
    affInfo: t("pubmed.author.affInfo"),
    not: t("pubmed.author.not"),
    authorInfo: t("pubmed.author.author-info"),
  };

  const journalDict = {
    title: t("journal.label.title"),
    nImpactFactor: t("journal.label.nImpactFactor"),
    publisherName: t("journal.label.publisher"),
    country: t("journal.label.country"),
    categories: t("journal.label.categories"),
    meshes: t("journal.label.meshes"),
    cardTitle: t("journal.itself"),
  };

  return (
    <div>
      <div className={journalStyle}>
        <JournalDescription
          journal={journal}
          journalInfo={journalInfo}
          articleDate={articleDate}
          publicationTypes={publicationTypes}
          doi={doi!}
          pmid={pmid!}
          dict={journalDict}
          medlineJournalInfo={medlineJournalInfo}
        />
      </div>
      <div className={authorStyle}>
        <Paragraph
          ellipsis={{
            rows: 1,
            expandable: true,
          }}
        >
          {authors.map((author, index) => (
            <AuthorDescription
              index={index}
              length={authors.length}
              author={author}
              key={`${author?.foreName}${author?.lastName}${author.initials}${index}`}
              dict={authorDict}
            />
          ))}
        </Paragraph>
      </div>
    </div>
  );
};

export default Description;
